var path = '/opt/atlassian/pipelines/agent/build/src/app/common/components/content-sequence/content-sequence.html';
var html = "<div class=\"col-md-12 col-lg-12 col-sm-12 col-xs-12 no-padding\"> <div class=sequence-list> <h2>Drag & drop the following items to change their sequence</h2> <ol id=slippylist> <li ng-repeat=\"content in list\" class=demo-no-reorder> <div class=sequence-content-list> <div class=sequence-icon> <img ng-src=/images/sequenceIcon.png class=\"img-responsive center-block\" alt=\"villa di maria\"> </div> <div class=sequence-content> <h4>{{ content.title }}</h4> </div> </div> </li> </ol> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/content-sequence/content-sequence.html
// module id = 908
// module chunks = 0